import httpService from './http.service';
import { API_URLS } from '../config/constants';

export interface GeneratePostPayload {
  productId: string;
  instagram: boolean;
  tiktok: boolean;
}

export interface SocialPostPlatform {
  enabled: boolean;
  postId?: string;
  publishStatus?: 'success' | 'failed';
  error?: string;
}

export interface SocialPost {
  _id: string;
  productId: string;
  productName: string;
  caption: string;
  originalImage: string;
  enhancedImage: string;
  status: 'created' | 'published';
  instagram: SocialPostPlatform;
  tiktok: SocialPostPlatform;
  createdAt: string;
}

export const generateSocialPost = (data: GeneratePostPayload) => httpService.post<SocialPost>(API_URLS.SOCIAL.GENERATE, data);

export const publishSocialPost = (id: string) => httpService.post<SocialPost>(API_URLS.SOCIAL.PUBLISH.replace('[id]', id));

export const getSocialPost = (id: string) => httpService.get<SocialPost>(API_URLS.SOCIAL.GET.replace('[id]', id));

export const getSocialPosts = (params: { skip: number; limit: number }) => httpService.get<{ data: SocialPost[]; total: number }>(API_URLS.SOCIAL.LIST, { params });
